import { render, staticRenderFns } from "./PaymentCanceled.vue?vue&type=template&id=1657e61b&"
import script from "./PaymentCanceled.vue?vue&type=script&lang=js&"
export * from "./PaymentCanceled.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCanceled.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports